export function resolveApiBaseUrl(raw: string | undefined): string {
	return (raw ?? "/api/v1").replace(/\/$/, "");
}

export function getApiBaseUrl(): string {
	return resolveApiBaseUrl(import.meta.env.VITE_API_BASE_URL);
}

export function extensionsMockEnabled(mode?: string): boolean {
	return (mode ?? import.meta.env.VITE_EXTENSIONS_MODE) !== "live";
}
